import angular from 'angular';
import { sqDigitalFilterActions } from '@/hybrid/tools/digitalFilter/digitalFilter.actions';

angular.module('Sq.Investigate').service('sqDigitalFilterActions', sqDigitalFilterActions);

export const DIGITAL_FILTER_MIN_CUTOFF_RATIO = 2;
